import React from 'react'
import { Icon } from './Close.elements'

type Props = {
  className?: string
}

export const CloseIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 48 48"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
  >
    <path
      fill="currentcolor"
      d="M4 39.52L19.52 24 4 8.48 8.48 4 24 19.52 39.52 4 44 8.48 28.48 24 44 39.52 39.52 44 24 28.48 8.48 44z"
    />
  </Icon>
)
